            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">       
        <b-form  inline style="margin-bottom:15px" novalidate> 
          <b-row style="width:100%;margin-bottom:20px"> 
            <sw-searchs
              v-if="dataIndex[namePath]===false"
              :md="6"
              :lg="6"
              label='Seleccionar afiliado'
              list='datos_afiliado'              
              @input="searchsData"
              filterCampos="documento"
              :filter="[{campo: 'id_list_estado', value: 1},{campo: 'servicios', value: 0}]"              
            >
            </sw-searchs>
            <b-col :md="6" :lg="6" style="padding-top: 35px;" 
              v-show="!statusLoading && searchSw.value!=''">
                <sw-loading></sw-loading> 
            </b-col> 
            <b-col :md="6" :lg="6" style="padding-top: 15px;" 
              v-if="dataIndex[namePath]!==false">
                <span>Afiliado</span> <br>
                 {{gettersDatalist('datos_afiliado',dataForm[namePath].info_incapacidades.id_datos_afiliado)[0].documento}} - {{gettersDatalist('datos_afiliado',dataForm[namePath].info_incapacidades.id_datos_afiliado)[0].name.toUpperCase()}}
            </b-col>             
            <sw-inputs
              v-show="statusLoading"
              inputTabla="info_incapacidades"
              inputCampo="id_datos_razon"
              :md="3" :lg="3">
            </sw-inputs>
            <sw-inputs
              v-show="statusLoading"
              inputTabla="info_incapacidades"
              inputCampo="fecha"
              :md="3" :lg="3">
            </sw-inputs>  
            <sw-inputs
              v-show="statusLoading"
              inputTabla="info_incapacidades"
              inputCampo="id_list_incapacidad"
              @input="changeListEntidad"
              :md="3" :lg="3">
            </sw-inputs> 
            <b-col :md="3" :lg="3" 
              v-show="statusLoading">
              <b-form-group label="Entidad">
                <c-multiselect
                  style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                  v-model="dataForm[namePath].info_incapacidades.name_entidad"                   
                  :options="lists[dataForm[namePath].info_incapacidades.name_list]"
                  label="name"
                  track-by="name"
                  :preselect-first="false"
                  :searchable="false"
                  placeholder="Seleccionar"
                  >
                </c-multiselect>
              </b-form-group>
            </b-col>      
            <sw-inputs
              v-show="statusLoading"
              inputTabla="info_incapacidades"
              inputCampo="fechaini"
              @input="changeDias"
              :md="3" :lg="3">
            </sw-inputs>  
            <sw-inputs
              v-show="statusLoading"
              inputTabla="info_incapacidades"
              inputCampo="fechafin"
              @input="changeDias"
              :md="3" :lg="3">
            </sw-inputs>  
            <sw-inputs
              v-show="statusLoading"
              inputTabla="info_incapacidades"
              inputCampo="dias"
              :md="3" :lg="3">
            </sw-inputs>   
            <sw-inputs
              v-show="statusLoading"
              inputTabla="info_incapacidades"
              inputCampo="proceso"
              :md="3" :lg="3">
            </sw-inputs>     
            <sw-inputs
              v-show="statusLoading"
              inputTabla="info_incapacidades"
              inputCampo="incapacidad"
              :md="3" :lg="3">
            </sw-inputs>     
            <sw-inputs
              v-show="statusLoading"
              inputTabla="info_incapacidades"
              inputCampo="id_list_proceso"
              :md="3" :lg="3">
            </sw-inputs>      
            <sw-inputs
              v-show="statusLoading"
              inputTabla="info_incapacidades"
              inputCampo="fechaproceso"
              :md="3" :lg="3">
            </sw-inputs>
            <b-col :md="9" :lg="9" class="pr-0" 
              v-show="statusLoading">
               <b-form-group label="Documentos recibidos:">
                <b-form-checkbox-group id="checkbox-group-2" v-model="dataForm[namePath].info_incapacidades.documentos" name="flavour-2">
                  <b-form-checkbox value="Cédula">Cédula</b-form-checkbox>
                  <b-form-checkbox value="Historia clinica">Historia clinica</b-form-checkbox>
                  <b-form-checkbox value="Inc. original">Inc. original</b-form-checkbox>
                  <b-form-checkbox value="Reporte accidente" v-if="dataForm[namePath].info_incapacidades.id_list_incapacidad===1">Reporte accidente</b-form-checkbox>
                  <b-form-checkbox value="Dane" v-if="dataForm[namePath].info_incapacidades.id_list_incapacidad===3 || dataForm[namePath].info_incapacidades.id_list_incapacidad===4">Dane</b-form-checkbox>
                  <b-form-checkbox value="Registro civil" v-if="dataForm[namePath].info_incapacidades.id_list_incapacidad===3 || dataForm[namePath].info_incapacidades.id_list_incapacidad===4">Registro civil</b-form-checkbox>
                  <b-form-checkbox value="Furips" v-if="dataForm[namePath].info_incapacidades.id_list_incapacidad===5">Furips</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>  
            <sw-inputs
              v-show="statusLoading"
              inputTabla="info_incapacidades"
              inputCampo="valor"
              :md="3" :lg="3">
            </sw-inputs>
            <b-col :md="12" :lg="12"  style="margin-top:25px" 
              v-show="statusLoading">
              <b-form-group label="Observaciones">
                <table class="table-striped" style="width:100%" v-if="dataIndex[namePath]!==false && dataForm[namePath].info_incapacidades.observaciones.length>0">
                  <tbody>
                    <tr  v-for="(items,index) in dataForm[namePath].info_incapacidades.observaciones" :key="'incapacidades'+index">
                      <td class="p-2">{{items}}</td>
                      <td class="p-2"><b-icon @click="eliminarObservacion(index)" style="cursor:pointer" :id="'eliminar'+index" icon="trash" scale="1.2" variant="danger"></b-icon> <b-tooltip triggers="hover" noninteractive :target="'eliminar'+index">Eliminar</b-tooltip></td>
                    </tr>
                  </tbody>
                </table>
                <b-form-input style="margin-top:15px" v-model="observaciones" ></b-form-input>
              </b-form-group>
            </b-col>                          
          </b-row>   
        </b-form>  
        <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            :index="dataIndex[namePath]"
            nameBtn="Incapacidad"
            :invalid="invalid"
            @save="save"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwModallistforma  from '@/components/modals/list_forma.vue'
import SwModallistcuentas  from '@/components/modals/list_cuentas.vue'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import Multiselect  from '@/components/vue-multiselect/src/'
import SwLoading from '@/components/notification/loading.vue'
import moment from 'moment'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform,
    SwModallistforma,
    SwModallistcuentas,
    'c-multiselect': Multiselect,
    SwSearchs,
    SwLoading 
  },
  props: {
  },
  data()
  {
    return {
      observaciones: null,
      statusLoading: false,
      dataBackend: {}
    }
  },
  async created(){
    if(this.dataIndex[this.namePath]===false)
    {
      await this.updateDataForm({state: 'info_incapacidades/fecha', data: this.fecha().fecha.minHoy})
      await this.updateDataForm({state: 'info_incapacidades/fechaproceso', data: this.fecha().fecha.minHoy})
    }
    else 
    {
      this.searchSw.value=this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_incapacidades.id_datos_afiliado
      await this.updateDataForm({state: 'info_incapacidades', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_incapacidades})
      this.statusLoading=true
    }
    
    
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  destroyed()
  {
    this.resetDataIndex()
    this.resetDataForm()
    this.searchSw.value=''
  },
  computed: { 
  },
  methods: {  
    eliminarObservacion(index)
    {
      this.spliceDataForm({state: 'info_incapacidades/observaciones', index:index})
    },
    async save(event)
    {      
      await this.updateDataForm({state: 'info_incapacidades/id_datos_afiliado', data: this.searchSw.value})
      if(this.observaciones!=null && this.observaciones!='')
      {
        await this.pushDataForm({state: 'info_incapacidades/observaciones', data: this.observaciones})
      }      
      this.$emit('save',{save:event.save, ftn: 'guardarFtn' })
    },
    async changeListEntidad(event) 
    {
      if(event.obj===1)
      {
        await this.updateDataForm({state:'info_incapacidades/name_list',data: 'list_arl'})
        await this.updateDataForm({state:'info_incapacidades/name_entidad',data: this.gettersDatalist('datos_razon',this.dataForm[this.namePath].info_incapacidades.id_datos_razon)[0].id_list_arl})
      }
      else 
      {
        await this.updateDataForm({state:'info_incapacidades/name_list',data: 'list_eps'})
        await this.updateDataForm({state:'info_incapacidades/name_entidad',data: this.dataBackend.servicios_activos.id_list})
      }
    },
    async searchsData() 
    {
      if(this.dataIndex[this.namePath]===false)
      {
        this.dataBackend= await  this.getData({route: 'afiliado_incapacidad', data: this.searchSw.value})
        await  this.updateDataForm({state:'info_incapacidades/id_datos_razon',data: this.dataBackend.info_afiliacion.id_datos_razon})

        await this.changeListEntidad({obj: this.dataForm[this.namePath].info_incapacidades.id_list_incapacidad})
        this.statusLoading=true
      }
    },
    async changeDias()
    {
      if(this.dataForm[this.namePath].info_incapacidades.fechaini!=null && this.dataForm[this.namePath].info_incapacidades.fechafin!=null)
      {
        let fechaini = moment(this.dataForm[this.namePath].info_incapacidades.fechaini)
        let fechafin = moment(this.dataForm[this.namePath].info_incapacidades.fechafin)
        let dias=parseInt(fechafin.diff(fechaini,'days'))+1
        await this.updateDataForm({state:'info_incapacidades/dias',data: dias})
      }
      
    }
  }
}
</script>
<style>
</style>